import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../context/AuthContext';

// Opaque AuthContext epochs keep credentials out of query keys and separate logins.
export default function useUserDetailScope(family, environment, token) {
  const { cacheSession, role, token: currentToken } = useAuth();
  const client = useQueryClient();
  useEffect(() => {
    const previousScope = [family, environment, cacheSession, role];
    return () => {
      client.cancelQueries({ queryKey: previousScope });
      client.removeQueries({ queryKey: previousScope });
    };
  }, [client, family, environment, cacheSession, role]);
  return {
    scope: [family, environment, cacheSession, role],
    authenticated: cacheSession != null && !!currentToken && currentToken === token,
  };
}
